import Vue from 'vue';
import Router from 'vue-router';
import Login from '../view/Login.vue'
import GroupLogin from '../view/GroupLogin.vue'
import register from '../view/Register.vue'
import print from '../view/print.vue'
import detail from '../view/Detail.vue'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' //样式必须引入

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {title: '会展数据管理系统'}
        },
        {
            path: '/group_login',
            name: 'group_login',
            component: GroupLogin,
            meta: {title: '团组登陆'}
        },
        {
            path: '/register',
            name: 'register',
            component: register,
            meta: {title: '入馆登记'}
        },
        {
            path: '/print',
            name: '/print',
            component: print,
            meta: {title: '快捷新增'}
        },
        {
            path: '/fanti',
            name: '/fanti',
            component: detail,
            meta: {title: '详细编辑'}
        },
        {
            path: '/',
            component: resolve => require(['../components/common/Home.vue'], resolve),
            meta: {title: '自述文件'},
            children: [
                {
                    path: '/dashboard',
                    component: resolve => require(['../view/Dashboard.vue'], resolve),
                    meta: {title: '首页'}
                },
                // 系统设置
                {
                    path: '/project-manage',
                    component: resolve => require(['../view/system/Project_Manage.vue'], resolve),
                    meta: {
                        title: '项目管理'
                    }
                }, {
                    path: '/project-type',
                    component: resolve => require(['../view/system/Project_Type.vue'], resolve),
                    meta: {
                        title: '项目类型'
                    }
                }, {
                    path: '/user-manage',
                    component: resolve => require(['../view/system/User_Manage.vue'], resolve),
                    meta: {
                        title: '用户管理'
                    }
                }, {
                    path: '/auth-profile',
                    component: resolve => require(['../view/system/Auth_Profile.vue'], resolve),
                    meta: {
                        title: '角色权限配置'
                    }
                }, {
                    path: '/role-manage',
                    component: resolve => require(['../view/system/User_Role_Manage.vue'], resolve),
                    meta: {
                        title: '用户角色管理'
                    }
                }, {
                    path: '/system-log',
                    component: resolve => require(['../view/system/System_log.vue'], resolve),
                    meta: {
                        title: '系统日志'
                    }
                }, {
                    path: '/meeting',
                    component: resolve => require(['../view/ticketing/meeting/meeting.vue'], resolve),
                    meta: {
                        title: '会议管理'
                    }
                }, {
                    path: '/meeting-document-type',
                    component: resolve => require(['../view/ticketing/meeting/meeting_document_type.vue'], resolve),
                    meta: {
                        title: '会议证件类型'
                    }
                }, {
                    path: '/meeting-record',
                    component: resolve => require(['../view/ticketing/meeting/meeting_record.vue'], resolve),
                    meta: {
                        title: '会议证件'
                    }
                },
                // 票务展-增票管理
                {
                    path: '/import-ticket',
                    component: resolve => require(['../view/ticketing/ticket/Import_ticket.vue'], resolve),
                    meta: {title: '生成实体票'}
                }, {
                    path: '/distribute-ticket',
                    component: resolve => require(['../view/ticketing/ticket/Distribute_Manage.vue'], resolve),
                    meta: {title: '赠票分发'}
                }, {
                    path: '/record-ticket',
                    component: resolve => require(['../view/ticketing/ticket/Record_ticket.vue'], resolve),
                    meta: {
                        title: '赠票记录'
                    }
                }, {
                    path: '/ticket-all',
                    component: resolve => require(['../view/ticketing/ticket/Ticket.vue'], resolve),
                    meta: {
                        title: '查询所有票'
                    }
                }, {
                    path: '/mobile-ticket',
                    component: resolve => require(['../view/ticketing/ticket/Mobile_Terminal.vue'], resolve),
                    meta: {title: '生成电子票'}
                }, {
                    path: '/ticket-type-manage',
                    component: resolve => require(['../view/ticketing/ticket/Ticket_Type_Manage.vue'], resolve),
                    meta: {
                        title: '票种管理'
                    }
                },
                {
                    path: '/room-type',
                    component: resolve => require(['../view/ticketing/hotel/Project_Room_Type.vue'], resolve),
                    meta: {title: '房间类型'}
                },
                {
                    path: '/room',
                    component: resolve => require(['../view/ticketing/hotel/Project_Room.vue'], resolve),
                    meta: {title: '房间管理'}
                },
                {
                    path: '/room-record',
                    component: resolve => require(['../view/ticketing/hotel/Project_Room_Record.vue'], resolve),
                    meta: {title: '房间记录'}
                },
                // 证件管理
                {
                    path: '/type-setting',
                    component: resolve => require(['../view/ticketing/certificate/Type_Setting.vue'], resolve),
                    meta: {title: '证件类型'}
                }, {
                    path: '/papers-record',
                    component: resolve => require(['../view/ticketing/certificate/Papers_Recored.vue'], resolve),
                    meta: {title: '证件记录'}
                }, {
                    path: '/print-record',
                    component: resolve => require(['../view/ticketing/certificate/Print_Recored.vue'], resolve),
                    meta: {title: '证件打印记录'}
                }, {
                    path: '/delete-record',
                    component: resolve => require(['../view/ticketing/certificate/Delete_Recored.vue'], resolve),
                    meta: {title: '证件删除记录'}
                },
                // {
                //     path: '/modify-record',
                //     component: resolve => require(['../view/ticketing/certificate/Modify_Recored.vue'], resolve),
                //     meta: {title: '证件更新记录'}
                // },
                {
                    path: '/document-record',
                    component: resolve => require(['../view/ticketing/certificate/Document_Recored.vue'], resolve),
                    meta: {title: '手机端证件记录'}
                }, {
                    path: '/head-manage',
                    component: resolve => require(['../view/ticketing/certificate/Head_Manage.vue'], resolve),
                    meta: {title: '头像管理'}
                }, {
                    path: '/distribute-document',
                    component: resolve => require(['../view/ticketing/certificate/Distribute_Manage.vue'], resolve),
                    meta: {title: '证件分发'}
                }, {
                    path: '/record-document',
                    component: resolve => require(['../view/ticketing/certificate/Record_Document.vue'], resolve),
                    meta: {title: '分发记录'}
                }, {
                    path: '/check-document',
                    component: resolve => require(['../view/ticketing/certificate/Check_Document.vue'], resolve),
                    meta: {title: '签到管理'}
                },
                // 票务展-售票管理
                {
                    path: '/price-setting',
                    component: resolve => require(['../view/ticketing/sell/Price_Setting.vue'], resolve),
                    meta: {title: '微信设置'}
                }, {
                    path: '/record-manage',
                    component: resolve => require(['../view/ticketing/sell/Record_Manage.vue'], resolve),
                    meta: {title: '购票记录'}
                },
                // 票务展-数据管理
                {
                    path: '/access-control',
                    component: resolve => require(['../view/ticketing/data/Access_Control.vue'], resolve),
                    meta: {title: '通行规则'}
                }, {
                    path: '/traffic-record',
                    component: resolve => require(['../view/ticketing/data/Traffic_Record.vue'], resolve),
                    meta: {title: '证件通行记录'}
                }, {
                    path: '/else-record',
                    component: resolve => require(['../view/ticketing/data/Else_Record.vue'], resolve),
                    meta: {title: '其他通行记录'}
                }, {
                    path: '/ticket-record',
                    component: resolve => require(['../view/ticketing/data/Ticket_Record.vue'], resolve),
                    meta: {title: '票通行记录'}
                }, {
                    path: '/statistics',
                    component: resolve => require(['../view/ticketing/data/Statistics.vue'], resolve),
                    meta: {title: '通行统计'}
                }, {
                    path: '/attendee',
                    component: resolve => require(['../view/ticketing/data/Attendee.vue'], resolve),
                    meta: {title: '回调记录'}
                }, {
                    path: '/report',
                    component: resolve => require(['../view/ticketing/data/Report.vue'], resolve),
                    meta: {title: '门禁点统计'}
                },
                //专业展-展商管理
                {
                    path: '/exhibition',
                    component: resolve => require(['../view/major/businessman/Exhibition_Manage.vue'], resolve),
                    meta: {title: '展商管理'}
                }, {
                    path: '/exhibitors_exhibits',
                    component: resolve => require(['../view/major/businessman/Exhibitors_Exhibits.vue'], resolve),
                    meta: {title: '参展展品'}
                },
                {
                    path: '/group-user',
                    component: resolve => require(['../view/major/Group_User.vue'], resolve),
                    meta: {title: '团组管理'}
                },
                {
                    path: '/Reception',
                    component: resolve => require(['../view/major/Reception.vue'], resolve),
                    meta: {title: '接待管理'}
                },
                // {
                //     path: '/vihicel_manage',
                //     component: resolve => require(['../view/major/committee/Vihicel_Manage.vue'], resolve),
                //     meta: {title: '车辆管理'}
                // }, {
                //     path: '/content_publish',
                //     component: resolve => require(['../view/major/committee/Content_Publish.vue'], resolve),
                //     meta: {title: '内容发布'}
                // },
                // {
                //     path: '/vote',
                //     component: resolve => require(['../view/major/Vote.vue'], resolve),
                //     meta: {title: '投票管理'}
                // },
                // {
                //     path: '/vote_item',
                //     component: resolve => require(['../view/major/VoteItem.vue'], resolve),
                //     meta: {title: '投票项目管理'}
                // },
                // {
                //     path: '/vote_record',
                //     component: resolve => require(['../view/major/VoteRecord.vue'], resolve),
                //     meta: {title: '投票记录'}
                // },
                {
                    path: '/register_ui_manage',
                    component: resolve => require(['../view/major/RegisterUI_Manage.vue'], resolve),
                    meta: {title: '注册通道'}
                },
                {
                    path: '/raffle',
                    component: resolve => require(['../view/major/Raffle.vue'], resolve),
                    meta: {title: '抽奖管理'}
                },
                {
                    path: '/project_property',
                    component: resolve => require(['../view/major/ProjectProperty.vue'], resolve),
                    meta: {title: '项目属性'}
                },
                //专业展 观众管理
                {
                    path: '/audience_manage',
                    component: resolve => require(['../view/major/Peronal.vue'], resolve),
                    meta: {title: '人员管理'}
                },
                {
                    path: '/Blacklist',
                    component: resolve => require(['../view/major/Blacklist.vue'], resolve),
                    meta: {title: '黑名单管理'}
                },
                //来源管理
                {
                    path: '/source_manage',
                    component: resolve => require(['../view/major/Source.vue'], resolve),
                    meta: {title: '来源管理'}
                },
                {
                    path: '/label_manage',
                    component: resolve => require(['../view/major/Label.vue'], resolve),
                    meta: {title: '标签管理'}
                },
                //联系人
                {
                    path: '/contact',
                    component: resolve => require(['../view/major/Contact.vue'], resolve),
                    meta: {title: '联系人'}
                },
                //信息模板
                {
                    path: '/Invite',
                    component: resolve => require(['../view/major/Invite.vue'], resolve),
                    meta: {title: '信息模板'}
                },
                //联系人
                {
                    path: '/contact_Invite',
                    component: resolve => require(['../view/major/Contact_Invite.vue'], resolve),
                    meta: {title: '信息记录'}
                },
                // {
                //     path: '/print',
                //     component: resolve => require(['../view/major/print.vue'], resolve),
                //     meta: { title: '快捷新增' }
                // },
                {
                    path: '/search',
                    component: resolve => require(['../view/major/Search.vue'], resolve),
                    meta: {title: '高级搜索'}
                },
                {
                    path: '/404',
                    component: resolve => require(['../components/page/404.vue'], resolve),
                    meta: {title: '404'}
                },
                {
                    path: '/Batch',
                    component: resolve => require(['../view/major/Batch.vue'], resolve),
                    meta: {title: '导入文件'}
                }
            ]
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
})

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

router.afterEach((to, form) => {
    NProgress.start();
    // 获取真实路由参数

    let query = window.location.search.substring(1);
    if (query.lastIndexOf('route=') > -1) {
        let routePath = query.substring(query.lastIndexOf('=') + 1);
        if (routePath) {
            // URI解码(将%2F解码为/)
            routePath = decodeURIComponent(routePath);
            // 如果默认跳转到首页,则不做二次路由跳转
            if (routePath !== '/index.html') {
                router.replace(routePath);
            }
        }
    }

    NProgress.done()
})

router.beforeEach((to, from, next) => {
    console.log(to.path)
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (to.path == '/login' || to.path == '/group_login') {
            next();
        } else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        }
    } else {
        next();
    }
})

export default router;
